import { REDUCER_STATUS } from "helpers/sf_constants"
import {
  GET_ANALYTICS,
  GET_ANALYTICS_SUCCESS,
  GET_ANALYTICS_ERROR,
  RESET_ANALYTICS,
  GET_ANALYTICS_EXPORT,
  GET_ANALYTICS_EXPORT_SUCCESS,
  GET_ANALYTICS_EXPORT_ERROR,
  RESET_ANALYTICS_EXPORT_ERROR,
  GET_CLICK_CONV_AGGR_ANALYTICS,
  GET_CLICK_CONV_AGGR_ANALYTICS_SUCCESS,
  GET_CLICK_CONV_AGGR_ANALYTICS_ERROR,
  GET_CLICK_CONV_AGGR_ANALYTICS_COMPARE_TO_SUCCESS,
  GET_ANALYTICS_COMPARE_TO_SUCCESS,
  RESET_ANALYTICS_COMPARED_TO,
  GET_CALL_OPPORTUNITIES,
  GET_CALL_OPPORTUNITIES_SUCCESS,
  GET_CALL_OPPORTUNITIES_ERROR,
  GET_CALL_OPPORTUNITIES_COMPARE_TO_SUCCESS,
  GET_CALL_OPPORTUNITIES_COMPARE_TO,
  GET_CALL_OPPORTUNITIES_COMPARE_TO_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  analytics: [],
  loading: false,
  total_analytics: [],
  analytics_pagination: null,
  loading_export: false,
  error_export: null,
  status_export: REDUCER_STATUS.UNKNOWN,
  click_conv_aggr_analytics: [],
  click_conv_aggr_analytics_total: [],
  click_conv_aggr_analytics_loading: false,
  compare_to_analytics: [],
  compare_to_analytics_loading: false,
  compare_to_total_analytics: [],
  compare_to_click_conv_aggr_analytics: [],
  compare_to_click_conv_aggr_analytics_loading: false,
  compare_to_click_conv_aggr_analytics_total: [],
  compare_to_main_data_api: false,
  call_opportunities: [],
  call_opportunities_loading: false,
  call_opportunities_total: [],
  compare_to_call_opportunities: [],
  compare_to_call_opportunities_loading: false,
  compare_to_call_opportunities_total: [],
  latest_analytics_request_id: null
}

const Analytics = (state = initialState, action) => {
  switch (action.type) {
    case RESET_ANALYTICS:
      return {
        ...initialState,
        loading_export: state.loading_export,
        error_export: state.error_export,
        status_export: state.status_export,
      }

    case GET_ANALYTICS:
      return {
        ...state,
        loading: action?.compare_to ? state.loading : true,
        compare_to_main_data_api: action?.compare_to ? true : state.compare_to_main_data_api,
        compare_to_analytics_loading: action?.compare_to ? true : state.compare_to_analytics_loading,
        latest_analytics_request_id: action?.compare_to ? state.latest_analytics_request_id : action.request_id
      }

    case GET_ANALYTICS_SUCCESS:
      if (action.request_id !== state.latest_analytics_request_id) {
        return state
      }
      return {
        ...state,
        analytics: action?.payload?.analytics || [],
        total_analytics: action?.payload?.total_analytics === undefined ? state.total_analytics : (action?.payload?.total_analytics || []),
        analytics_pagination: action?.payload?.pagination || null,
        loading: false
      }

    case GET_ANALYTICS_ERROR:
      if (action.request_id && action.request_id !== state.latest_analytics_request_id) {
        return state
      }
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case GET_CLICK_CONV_AGGR_ANALYTICS:
      return {
        ...state,
        click_conv_aggr_analytics_loading: action?.compare_to ? state.click_conv_aggr_analytics_loading : true,
        compare_to_click_conv_aggr_analytics_loading: action?.compare_to ? true : state.compare_to_click_conv_aggr_analytics_loading
      }

    case GET_CLICK_CONV_AGGR_ANALYTICS_SUCCESS:
      return {
        ...state,
        click_conv_aggr_analytics: action.payload.conv_aggr_stats,
        click_conv_aggr_analytics_total: action.payload.total_aggr_stats,
        click_conv_aggr_analytics_loading: false,
        error: null
      }

    case GET_CLICK_CONV_AGGR_ANALYTICS_ERROR:
      return {
        ...state,
        error: action.payload,
        click_conv_aggr_analytics_loading: false
      }

    case GET_ANALYTICS_EXPORT:
      return {
        ...state,
        loading_export: true,
        error_export: null,
      }

    case GET_ANALYTICS_EXPORT_SUCCESS:
      return {
        ...state,
        loading_export: false,
        status_export: REDUCER_STATUS.OK
      }

    case GET_ANALYTICS_EXPORT_ERROR:
      return {
        ...state,
        error_export: action.payload,
        loading: false,
        status_export: REDUCER_STATUS.ERROR
      }

    case RESET_ANALYTICS_EXPORT_ERROR:
      return {
        ...state,
        error_export: null,
        loading: false,
        status_export: REDUCER_STATUS.UNKNOWN
      }
    
    case GET_ANALYTICS_COMPARE_TO_SUCCESS:
      return {
        ...state,
        compare_to_analytics_loading: false,
        compare_to_analytics: action?.payload?.analytics,
        compare_to_total_analytics: action?.payload?.total_analytics || [],
      }

    case GET_CLICK_CONV_AGGR_ANALYTICS_COMPARE_TO_SUCCESS:
      return {
        ...state,
        compare_to_click_conv_aggr_analytics_loading: false,
        compare_to_click_conv_aggr_analytics: action?.payload?.conv_aggr_stats,
        compare_to_click_conv_aggr_analytics_total: action?.payload?.total_aggr_stats
      }
    case RESET_ANALYTICS_COMPARED_TO:
      return {
        ...state,
        compare_to_analytics: [],
        compare_to_click_conv_aggr_analytics: [],
        compare_to_main_data_api: false,
      }
    case GET_CALL_OPPORTUNITIES:
      return {
        ...state,
        call_opportunities_loading: true,
        call_opportunities: [],
        call_opportunities_total: []
      }
    case GET_CALL_OPPORTUNITIES_SUCCESS:
      return {
        ...state,
        call_opportunities_loading: false,
        call_opportunities: action?.payload?.analytics,
        call_opportunities_total: action?.payload?.total_analytics
      }
    case GET_CALL_OPPORTUNITIES_ERROR:
      return {
        ...state,
        error: action.payload,
        call_opportunities_loading: false
      }
    case GET_CALL_OPPORTUNITIES_COMPARE_TO:
      return {
        ...state,
        compare_to_call_opportunities_loading: true,
        compare_to_call_opportunities: [],
        compare_to_call_opportunities_total: []
      }
    case GET_CALL_OPPORTUNITIES_COMPARE_TO_SUCCESS:
      return {
        ...state,
        compare_to_call_opportunities_loading: false,
        compare_to_call_opportunities: action?.payload?.analytics,
        compare_to_call_opportunities_total: action?.payload?.total_analytics
      }
    case GET_CALL_OPPORTUNITIES_COMPARE_TO_ERROR:
      return {
        ...state,
        error: action.payload,
        compare_to_call_opportunities_loading: false
      }
    default:
      return state
  }
}

export default Analytics
